import { object, string } from 'yup'
import { t } from 'ttag'

import { POSITION_FIELD, STATUS_FIELD } from './model'

export const getSchema = () =>
  object().shape({
    [POSITION_FIELD]: object()
      .shape({ label: string(), value: string() })
      .required(t`This field cannot be empty.`),
    [STATUS_FIELD]: object()
      .shape({ label: string(), value: string() })
      .required(t`This field cannot be empty.`),
  })
